import { IBrazilianStates } from 'entities';
import { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { useTheme } from 'styled-components';
import { Button, MenuOptionLeftUser, NavHeader } from '../../components';
import { IRef, ServiceValues } from './ServiceValues';
import { Container, ContainerValues, Content, LineFlat } from './styles';
import { useJobValues } from '../../context/jobvalues';
import { BRAZILIAN_STATES } from '../../constants';
import { State } from './State';
import TitlePage from '../../components/TitlePage';
import JoyrideTour from '../../components/JoyrideTour';
import { myValuesSteps } from '../../constants/Tour/Steps/myValuesSteps';
import { TutorialType } from '../../types/enums';
import { useAuth } from '../../context';

export function MyValues() {
  const { user } = useAuth();
  const { colors } = useTheme();
  const specialtyComponentRef = useRef<IRef>(null);
  const { isLoadingJobValues, stateSelected, setStateSelected } = useJobValues();
  const [isChangingState, setIsChangingState] = useState(false);
  const [runningTutorial, setRunningTutorial] = useState(false);
  const methods = useForm();

  const handleSetStateSelected = async (state: IBrazilianStates) => {
    setStateSelected(state);
    setIsChangingState(true);

    const timer: NodeJS.Timeout = setTimeout(() => {
      setIsChangingState(false);
    }, 500);
    return () => clearTimeout(timer);
  };

  const handleTutorialSteps = (target: string) => {
    if (target === '#my-values') {
      setStateSelected(BRAZILIAN_STATES[0]);
    }
  };

  useEffect(() => {
    if (!user?.tutorialProgress?.some((p) => p === TutorialType.MY_VALUES)) {
      setRunningTutorial(true);
    }
  }, [user.tutorialProgress]);

  return (
    <>
      <JoyrideTour
        steps={myValuesSteps}
        type={TutorialType.MY_VALUES}
        run={runningTutorial}
        onCallbackFinished={() => setRunningTutorial(false)}
        onStepChange={handleTutorialSteps}
      />
      <NavHeader typeHeader="company" />
      <Container>
        <MenuOptionLeftUser />
        <Content>
          <div style={{ width: '100%', height: '-webkit-fill-available' }}>
            <TitlePage
              title="Meus Valores"
              onRequestOpen={() => {
                setRunningTutorial(true);
              }}
              id="start-item"
            />

            <div className="container-cities">
              <div className="new-cities">
                <p>Estados</p>
              </div>
              <div className="cities-user" id="select-state">
                {BRAZILIAN_STATES.map((state) => (
                  <State
                    key={state.ufCode}
                    state={state.name}
                    isSelected={state.ufCode === stateSelected?.ufCode}
                    disabled={isChangingState || isLoadingJobValues}
                    onClick={() => handleSetStateSelected(state)}
                  />
                ))}
              </div>
            </div>
            <LineFlat />
            <ContainerValues>
              {stateSelected && <p>{`${stateSelected?.name}`}</p>}
              <FormProvider {...methods}>
                {!isLoadingJobValues ? (
                  stateSelected ? (
                    <ServiceValues
                      isTutorial={runningTutorial}
                      data={{
                        ufCode: stateSelected.ufCode,
                      }}
                      ref={specialtyComponentRef}
                      loading={isChangingState}
                    />
                  ) : (
                    <Grid container justifyContent="center" alignContent="center">
                      <Typography align="center" color={colors.gray_300}>
                        Selecione um estado para visualizar seus valores.
                      </Typography>
                    </Grid>
                  )
                ) : (
                  <Grid
                    container
                    padding="2rem"
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    gap="0.5rem">
                    <CircularProgress size={15} />
                    <Typography variant="caption" color={colors.text} sx={{ fontStyle: 'italic' }}>
                      Carregando...
                    </Typography>
                  </Grid>
                )}
              </FormProvider>
            </ContainerValues>
          </div>
          {stateSelected && (
            <Grid className="container-button-save" container>
              <Button
                text="Salvar"
                id="save"
                disabled={isChangingState}
                dimensions={{ width: 150, height: 36 }}
                onClick={() => specialtyComponentRef.current?.handleUpdate()}
              />
            </Grid>
          )}
        </Content>
      </Container>
    </>
  );
}
